import React from 'react';
import TextInput from "@/components/UI/Form/Inputs/TextInput/TextInput";
import {NextButton, SignUpPasswordInput, SignUpPhoneInput} from "@/components/Auth/SignUp/SignUp.styled";
import EmailInput from "@/components/UI/Form/Inputs/EmailInput/EmailInput";
import {useTranslations} from "next-intl";

const SignUpFields = ({ emailAddress, setEmailAddress }) => {
    const tf = useTranslations('Fields')
    const tm = useTranslations('Main.Buttons')

    return (
        <>
            <TextInput
                name={'first_name'}
                label={tf('first_name')}
                variant={'convex'}
            />
            <TextInput
                name={'last_name'}
                label={tf('last_name')}
                variant={'convex'}
            />
            <SignUpPhoneInput
                name={'phone'}
                label={tf('phone_number')}
                variant={'convex'}
            />
            <EmailInput
                name={'email'}
                label={tf('email')}
                variant={'convex'}
                value={emailAddress}
                onChange={e => setEmailAddress(e)}
            />
            <SignUpPasswordInput
                name={'password'}
                label={tf('password')}
                variant={'convex'}
            />
            <SignUpPasswordInput
                name={'password_confirmation'}
                label={tf('confirm_password')}
                variant={'convex'}
            />
            <NextButton type={'submit'}>{tm('next')}</NextButton>
        </>
    );
};

export default SignUpFields;